// LineRaceChart.jsx
import React, { useEffect, useRef, useState } from "react";
import ReactECharts from "echarts-for-react";
import { FaChartBar, FaChartLine, FaDownload } from "react-icons/fa";

const SingleTypeLineChart = ({ data, chartTypeData }) => {
  const chartRef = useRef(null);
  const [chartType, setChartType] = useState("line");
  useEffect(() => {
    if (chartTypeData) setChartType(chartTypeData);
  }, [chartTypeData]);

  const handleChartChange = (type) => {
    setChartType(type);
  };

  const getOption = () => {
    const timeLabels = data.map((item) => item.time);
    const seriesNames = Object.keys(data[0] || {}).filter(
      (key) => key !== "time"
    );

    // /////////////////OPTION /////////////////////////////////////
    let dataZoom;
    const dataLength = data.length;
    if (dataLength <= 12) {
      dataZoom = 100;
    } else if (dataLength >= 12 && dataLength <= 36) {
      dataZoom = 50;
    } else if (dataLength >= 36 && dataLength <= 48) {
      dataZoom = 30;
    } else if (dataLength >= 48) {
      dataZoom = 20;
    }

    let singleDataGridOption = {
      left: "1%",
      right: "1%",
      top: "35%",
      bottom: "0%",
      containLabel: true,
    };
    // Define custom colors per series
    const lineColors = {
      PASS: "#ec425b", // red
      GOODS: "#2ecc71", // green
      SPEED: "#ecba42", // orange-yellow
      LDG_WGN: "#4280ec", // blue
      LOADING: "#4280ec", // same as LDG_WGN
      DWB: "#118d18", // dark green
      LDG_MT: "#fa9d4a", // orange
      RECEIPT_RKS: "#42beec", // light blue
      DESP_RKS: "#ec425b", // red

      TOTAL_RKS: "#8e44ad", // purple
      LD_RECEIPT: "#1abc9c", // teal
      NTKMS: "#f1c40f", // bright yellow
      WKMS: "#3498db", // mid blue
      WTR: "#e67e22", // orange
      DSL_KM: "#9b59b6", // lavender purple
      AC_KM: "#2c3e50", // dark gray-blue
      TOTAL_KM: "#16a085", // deep teal
      EMPTY_W_KM: "#95a5a6", // gray
      LOADED_W_KM: "#2980b9", // strong blue

      DSL_USG: "#c0392b", // dark red
      AC_USG: "#27ae60", // strong green
      SPEED_INCLU_STB: "#f39c12", // amber
      PUN_MAIL: "#d35400", // burnt orange
      PUN_PASS: "#7f8c8d", // muted gray
      UNLDG_WGN: "#8e44ad", // purple
      EARN_CRORES: "#ffd700", // gold
      MEXP_RPT: "#1e8449", // forest green
      PASS_RPT: "#e74c3c", // red
      TOD_RPT: "#5dade2", // soft blue
      MO_YR_ID: "#566573", // slate gray
    };

    return {
      tooltip: {
        trigger: "axis",
      },
      legend: {
        data: seriesNames,
        show: false,
      },
      xAxis: {
        type: "category",
        data: timeLabels,
        axisLabel: {
          // interval: 0,
          color: "black",
        },
      },
      yAxis: {
        type: "value",
        name: "",
        position: "left",
        axisLabel: {
          fontSize: 9,
          color: "black",
        },
      },

      grid: singleDataGridOption,
      //   dataZoom: [
      //     {
      //       type: "slider",
      //       show: true, // hiding the scroll bar is there is only one entity
      //       xAxisIndex: 0,
      //       start: 0,
      //       end: dataZoom, // adjust this percentage as needed
      //     },
      //     {
      //       type: "inside",
      //       xAxisIndex: 0,
      //       start: 0,
      //       end: 50, // sync with slider
      //       height: 15,
      //     },
      //   ],
      series: seriesNames.map((name) => {
        let color = lineColors[name];

        return {
          name,
          type:
            chartType === "line" ? "line" : chartType === "bar" ? "bar" : null,
          label: {
            show: true,
            position: "top",

            fontSize: 10,
            color: color,
            fontWeight: "bold",
            formatter: (params) => params.value,
          },
          labelLayout: {
            hideOverlap: true, // hides label if it still overlaps
            adjustPosition: true, // dynamically move labels to avoid overlap
          },

          data: data.map((item) => ({
            value: item[name],
            label: {
              show: true,
              position: "top",
              formatter: item[name.replace("_", " ")],
              color: color,
              fontWeight: "bold",
              fontSize: 10,
            },
          })),
          lineStyle: {
            color: color,
            width: 3,
          },
          itemStyle: {
            color: color,
          },
          animationDuration: 2000,
          animationEasing: "linear",
          smooth: true,
          markPoint: {
            data: [
              {
                type: "max",
                name: "max",
                label: {
                  formatter: "{b}",
                  color: color,
                  fontWeight: "bold",
                },
                itemStyle: {
                  color: "rgb(0, 0, 0, 0.0)",
                },
              },
              {
                type: "min",
                name: "min",
                label: {
                  formatter: "{b}",
                  color: color,
                  fontWeight: "bold",
                },
                itemStyle: {
                  color: "rgb(0, 0, 0, 0.0)",
                },
              },
            ],
          },
        };
      }),
    };
  };

  return (
    <div>
      {data.length === 0 ? "No Data Found" : null}
      {!chartTypeData ? (
        <div className="d-flex justify-content-end  ">
          <button
            className={`btn  btn-sm btn-outline-dark d-flex align-item-center me-1 ${
              chartType === "bar" ? "active" : ""
            }`}
            style={{ height: "25px" }}
            onClick={() => {
              handleChartChange("bar");
            }}
          >
            <FaChartBar />
          </button>
          <button
            className={`btn  btn-sm btn-outline-dark d-flex align-item-center me-1 ${
              chartType === "line" ? "active" : ""
            }`}
            style={{ height: "25px" }}
            onClick={() => {
              handleChartChange("line");
            }}
          >
            <FaChartLine />
          </button>
        </div>
      ) : null}

      <ReactECharts
        ref={chartRef}
        option={getOption()}
        notMerge={true}
        style={{
          height: "100px",
          width: "100%",
        }}
      />
    </div>
  );
};

export default SingleTypeLineChart;
